import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import React, { Suspense, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";

import cafea from "assets/images/servicii/cafea.webp";

const GoogleMaps = React.lazy(() => import("./components/GoogleMaps"));
const ContactUsForm = React.lazy(() => import("./components/ContactUsForm"));
const ContactUsDetails = React.lazy(() => import("./components/ContactUsDetails"));
const MKBox = React.lazy(() => import("components/MKBox"));
const MKTypography = React.lazy(() => import("components/MKTypography"));

function Contact() {
    const imageRef = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setVisible(true);
    }, []);

    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Helmet>
                <title>Contact | Doral Cleaning</title>
                <link rel="canonical" href="https://doral-cleaning.ro/contact-curatenie/" />
                <meta
                    name="description"
                    content="Ai nevoie de curățenie profesională? Contactează-ne pentru o ofertă personalizată. Suntem aici pentru a-ți oferi soluții eficiente și rapide. Sună acum!"
                />
            </Helmet>
            <GoogleMaps />
            <Container>
                <Grid container spacing={3}>
                    {/* Stânga: imaginea + text sub ea */}
                    <Grid item xs={12} lg={4}>
                        <MKBox
                            display="flex"
                            flexDirection="column"
                            justifyContent="flex-start"
                            bgColor="grey-100"
                            borderRadius="xl"
                            width="100%"
                            pt={3.5}
                            pb={3}
                            px={3}
                        >
                            {/* Textul vine primul */}
                            <MKBox pt={{ xs: 3, md: 0 }} pl={2} lineHeight={1}>
                                <MKTypography
                                    display="block"
                                    variant="5"
                                    color="dark"
                                    fontWeight="bold"
                                    mb={1}
                                >
                                    Promisiuni de calitate
                                </MKTypography>
                                <MKTypography display="block" variant="body2" color="text" mb={2}>
                                    Punem accent pe calitate, profesionalism și relații bazate pe
                                    încredere. Ne asigurăm că fiecare serviciu oferit răspunde
                                    așteptărilor și nevoilor clienților noștri.
                                    <br />
                                    <br />
                                    Hai să discutăm la o cafea!
                                    <br />
                                    Împreună vom pune bazele unei colaborări de succes!
                                </MKTypography>
                            </MKBox>

                            {/* Imaginea vine după text */}
                            <MKBox
                                component="img"
                                src={cafea}
                                alt="Cafea"
                                borderRadius="lg"
                                mt={3}
                                width="100%"
                                maxHeight="340px"
                                sx={{ objectFit: "cover" }}
                            />
                        </MKBox>
                    </Grid>

                    {/* Centru: formular */}
                    <Grid
                        item
                        xs={12}
                        lg={4}
                        ref={imageRef}
                        display="flex"
                        flexDirection=""
                        justifyContent="center"
                        sx={{
                            opacity: visible ? 1 : 0,
                            transform: visible ? "translateX(0)" : "translateX(-50px)",
                            transition: "opacity 0.8s ease-out, transform 0.8s ease-out",
                        }}
                    >
                        <ContactUsForm color="info" />
                    </Grid>

                    {/* Dreapta: date contact */}
                    <Grid
                        item
                        xs={12}
                        lg={4}
                        ref={imageRef}
                        display="flex"
                        flexDirection=""
                        justifyContent="center"
                        sx={{
                            opacity: visible ? 1 : 0,
                            transform: visible ? "translateX(0)" : "translateX(-50px)",
                            transition: "opacity 0.8s ease-out, transform 0.8s ease-out",
                        }}
                    >
                        <ContactUsDetails color="info" />
                    </Grid>
                </Grid>
            </Container>
        </Suspense>
    );
}

export default Contact;
